import { useState } from "react";
import { deleteSucursal, getSucursalesLista } from "../../services/SucursalesServices";
import { SucursalesContext } from "./SucursalesContext"

export const SucursalesState = ({ children }) => {

    const getSucursalesListaData = async () => {
        let res = await getSucursalesLista()
        return res
    }

    const deleteSucursalData = async (body) => {
        const res = await deleteSucursal(body)
        if (res) getSucursalesListaData()
        return res
    }


    return <SucursalesContext.Provider value={{
        deleteSucursalData,
        getSucursalesListaData,
    }} >
        {children}
    </SucursalesContext.Provider>
}